export default __webpack_public_path__ + "static/media/cost-estimation-basics-1.90ce02b8.svg";